import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-cookie-consent', 'title', 'Our cookies, your choices');
Labels.set(
    'ui-cookie-consent',
    'info',
    'Swedbank Group {entitiesLink} registered in {country} use {cookiesLink} (or similar technologies) to provide you personalized experience and to improve performance of the website. For more information, see our {policyLink}.\n\nBy pressing “Accept“ you consent to optional analytical and targeting cookies, whereas by pressing “Decline” you refuse these cookies.  You can also manage your choice of optional cookies below. You may withdraw your consent at any time on our {usageLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'disclaimer',
    'Some cookies are necessary for this website functioning and processed based on our legitimate interest, therefore your consent is not asked. Third-party cookies are used on this website.'
);
Labels.set('ui-cookie-consent', 'accept', 'Accept');
Labels.set('ui-cookie-consent', 'decline', 'Decline');
Labels.set('ui-cookie-consent', 'saveChoice', 'Save my choice');
Labels.set('ui-cookie-consent', 'myCookies', 'Select your own cookies');
Labels.set('ui-cookie-consent', 'policyLinkLabel', 'Cookie Policy');
Labels.set('ui-cookie-consent', 'help', {
    NECESSARY:
        'Are necessary for the website to function. These cookies cannot be switched off; hence the user consent is not asked.',
    ANALYTICAL:
        'Help to improve performance of the website by counting site visits and traffic sources.  If declined, your browsing of this website will not be part of our statistics.',
    TARGETING:
        'Help to provide you with personalized information about our products and services. If declined, personalized content will not be presented to you.',
});
Labels.set('ui-cookie-consent', 'categories', {
    NECESSARY: 'Necessary',
    ANALYTICAL: 'Analytical',
    TARGETING: 'Targeting',
});
Labels.set('ui-cookie-consent', 'EE', 'Estonia');
Labels.set('ui-cookie-consent', 'LV', 'Latvia');
Labels.set('ui-cookie-consent', 'LT', 'Lithuania');
Labels.set('ui-cookie-consent', 'entities', 'entities');
Labels.set('ui-cookie-consent', 'cookies', 'cookies');
Labels.set('ui-cookie-consent', 'language', 'Language');
Labels.set('ui-cookie-consent', 'usage', 'Cookies usage page');
